import LeaderboardTable from "../../student/leaderBoard/LeaderboardTable";
import SelfPosition from "../../student/leaderBoard/SelfPosition";

import { useGetQuizMarksQuery } from '../../../features/quizMarks/quizMarksApi'
import { useGetAssignmentMarksQuery } from '../../../features/assignmentMarks/assignmentMarksApi'
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useGetStudentsQuery } from "../../../features/auth/authApi";

export default function Leaderboard() {
  const { user } = useSelector(state => state.auth)
  const [leaderboard, setLeaderboard] = useState([])
  const [self, setSelf] = useState([])


  const { data: students } = useGetStudentsQuery();
  const { data: quizMarks = [] } = useGetQuizMarksQuery();
  const { data: assignmentMarks = [] } = useGetAssignmentMarksQuery();


  useEffect(() => {
    let studentsWithMarks = []
    if (students?.length) {
      students.map(student => {
        const filterdAssignments = assignmentMarks?.length ? assignmentMarks.filter(a => a.student_id == student.id && a.status == 'published') : [];

        const filterdQuizzes = quizMarks?.length ? quizMarks.filter(a => a.student_id == student.id) : []

        const assignmentMark = filterdAssignments.reduce((a, b) => a + Number(b.mark), 0);
        const quizMark = filterdQuizzes.reduce((a, b) => a + Number(b.mark), 0);
        studentsWithMarks.push({
          ...student,
          assignmentMark,
          quizMark,
          totalObtainedMarks: assignmentMark + quizMark,
          totalMark: [...filterdAssignments, ...filterdQuizzes].reduce((a, b) => a + Number(b.totalMark), 0)
        })
        const sortedStudentData = studentsWithMarks.sort((a, b) => b.totalObtainedMarks - a.totalObtainedMarks);
        let rank = 1;
        let prevTotalObtainMark = null;

        sortedStudentData.forEach((student, index) => {
          if (student.totalObtainedMarks !== prevTotalObtainMark) {
            student.rank = rank;
            prevTotalObtainMark = student.totalObtainedMarks;
          } else {
            student.rank = rank - 1;
          }
          rank++;
        });

        const loggedInStudent = sortedStudentData.find(a => a.id == user?.id)

        const topStudents = sortedStudentData.filter(s => s.rank <= 20 && s.totalObtainedMarks > 0)
        setLeaderboard(topStudents)
        setSelf(loggedInStudent)
      })
    }
  }, [students, quizMarks, assignmentMarks])

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <SelfPosition data={self} />

        <LeaderboardTable students={leaderboard} user={user} />
      </div>
    </section>
  )
}